const binding = { modules: {}, dataActions: {} };

    (binding.modules['returns-information-page'] = {
        c: () => require('partner/modules/returns-information-page/returns-information-page.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'returns-information-page',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/returns-information-page'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|returns-information-page|returns-information-page'] = {
                c: () => require('partner/modules/returns-information-page/returns-information-page.view.tsx'),
                cn: '__local__-__local__-returns-information-page'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };